import React from 'react';
import styles from './index.module.scss';
import { NavLink } from 'react-router-dom';

// Components
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const NavigationItem = (props) => (
    <NavLink /* onClick={props.onClick} */ to={props.to ? `/${props.to}` : '/'} className={styles.NavigationItem} activeClassName={styles.activeItem} exact={props.exact}>
        <div>
            <FontAwesomeIcon icon={props.icon} className={styles.Icon} />
            <span>{props.label}</span>
        </div>
    </NavLink>
);

export default NavigationItem;